import axiosInstance from "../AxiosInstance";

function parseAmount(amount) {
    const num = parseFloat(amount);
    if (isNaN(num)) return '0,00'; // optional: handle invalid input
    return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function downloadExcel() {
    axiosInstance.get('purchase_order/excel/', {
        responseType: 'blob'
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'documentos-proveedor.xlsx');
        document.body.appendChild(link);

        // Simulate a click event to trigger the download
        link.click();

        // Clean up the temporary link and URL object
        link.remove();
        window.URL.revokeObjectURL(url);
    });
}

export {
    downloadExcel,
    parseAmount,
}